import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M20.61,11.46a1,1,0,1,0-.9,1.7c1.51.79,2.37,1.77,2.37,2.69,0,1.83-3.15,3.61-7.32,4.14A1,1,0,0,0,15,21.9c5.38-.7,9-3.13,9-6C24,14.17,22.8,12.61,20.61,11.46Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M10.42,18.88a.48.48,0,0,0-.52-.11.49.49,0,0,0-.3.44v.66c0,.17-.12.16-.18.15-4.66-.55-7.5-2.51-7.5-4.17,0-.92.86-1.9,2.37-2.69a1,1,0,0,0-.9-1.7C1.2,12.61,0,14.17,0,15.85c0,3,3.87,5.48,9.36,6.1a.24.24,0,0,1,.24.24v.86a.49.49,0,0,0,.3.45.86.86,0,0,0,.52-.11l1.92-1.92a.47.47,0,0,0,0-.67Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M12,.49A6.25,6.25,0,0,0,5.76,6.73c0,2.76,3.83,8.16,5.48,10.35a.94.94,0,0,0,1.52,0c1.65-2.19,5.48-7.59,5.48-10.35A6.25,6.25,0,0,0,12,.49Zm0,8.64a2.4,2.4,0,1,1,2.4-2.4A2.4,2.4,0,0,1,12,9.13Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }